// ======================================================================
// File Name       : TopAction
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import { decamelizeKeys, camelizeKeys } from 'humps';
import { ENTERPRISE_NOTICE_LIST } from '../constants/ActionTypes';
import { commonCallApi } from '../utils/ApiUtils';
import * as top from './httpRequests/top';
import * as topActionCreators from './actionCreators/top';
import * as serviceActionCreators from './actionCreators/service';
import * as EnterpriseNotificationAction from '../actions/enterpriseNotification/EnterpriseNotificationAction';
import * as UsageSettingLiveActions from '../actions/UsageSettingLiveActions';
import * as enterpriseNotification from './httpRequests/enterpriseNotification';
import * as serviceRequest from './httpRequests/service';
import * as enterpriseNotificationActionCreators from './actionCreators/enterpriseNotification/enterpriseNotificationActionCreators';
import { RETURN_MAX_NUM_TOP } from '../constants';
import { SERVICE_TYPE } from '../constants/ServiceConstant';
import * as usageStatus from './httpRequests/usageStatus';
import * as usageStatusActionCreators from './actionCreators/usageStatus';

export function doNotificeList(
  paramForNoticeList,
  paramForService,
  paramForSystem,
  displayUserType,
) {
  return async (dispatch, getState) => {
    const responseForSystem = await top.doNotificeForSystemList(paramForSystem);
    const systemNotice = {
      recordNum: responseForSystem.recordNum,
      noticeList: responseForSystem.noticeList,
    };
    const responseForEnterprise = await enterpriseNotification.getEnterpriseNotificationList(paramForNoticeList, displayUserType);
    const responseForService = await serviceRequest.getServiceNotificationList(paramForService);
    dispatch(topActionCreators.getNoticeForEnterprise(systemNotice));
    dispatch(enterpriseNotificationActionCreators.enterpriseNotificationList(responseForEnterprise));
    dispatch(serviceActionCreators.receiveServiceNotificationList(responseForService));
  };
}

export function getNoticeSystem(paramForSystem) {
  return async (dispatch) => {
    const responseForSystem = await top.doNotificeForSystemList(paramForSystem);
    const systemNotice = {
      recordNum: responseForSystem.recordNum,
      noticeList: responseForSystem.noticeList,
    };
    dispatch(topActionCreators.getNoticeForEnterprise(systemNotice));
  };
}

export function getNoticeEnterprise(paramForEnterprise, displayUserType) {
  return async (dispatch) => {
    const responseForEnterprise = await enterpriseNotification.getEnterpriseNotificationList(paramForEnterprise, displayUserType);
    dispatch(enterpriseNotificationActionCreators.enterpriseNotificationList(responseForEnterprise));
  };
}

export function getNoticeService(paramForService) {
  return async (dispatch) => {
    const responseForService = await serviceRequest.getServiceNotificationList(paramForService);
    dispatch(serviceActionCreators.receiveServiceNotificationList(responseForService));
  };
}

export function getNoticeEnterpriseDetail(noticeEnterprise) {
  return async (dispatch) => {
    dispatch(topActionCreators.getNoticeEnterpriseDetail(noticeEnterprise));
  };
}

export function getNoticeServiceDetail(noticeService) {
  return async (dispatch) => {
    dispatch(topActionCreators.getNoticeServiceDetail(noticeService));
  };
}

export function getCurrentUsageStatus(displayUserType) {
  return async (dispatch) => {
    const resData = await usageStatus.postGetCurrentStatus(displayUserType);
    dispatch(usageStatusActionCreators.getCurrentUsageStatus(resData));
  };
}